export default __webpack_public_path__ + "static/media/gamestack-list.6a197023.jpg";